import { cn } from '#app/utils/misc.js'

/**
 * The festival house as a small glyph: navy house, ember chimney, a lit
 * window and the door standing ajar with light pouring out — the logo,
 * reduced to what reads at 24–40px. The door swings further open when a
 * parent `.group` is hovered.
 */
export function HouseMark({ className }: { className?: string }) {
	return (
		<svg
			viewBox="0 0 32 32"
			aria-hidden="true"
			className={cn('overflow-visible', className)}
		>
			<path
				d="M21.2 10.4V5.2h3.4v8.4Z"
				fill="#d2481a"
				stroke="#1c1a22"
				strokeWidth="1.4"
				strokeLinejoin="round"
			/>
			<path
				d="M4.6 14.8 16 4.2l11.4 10.6V28.4H4.6Z"
				fill="#323b53"
				stroke="#1c1a22"
				strokeWidth="1.6"
				strokeLinejoin="round"
			/>
			<rect x="13.5" y="9.6" width="5" height="4.4" rx="0.7" fill="#f6d77a" />
			<path d="M11.8 28.4v-9.6h8v9.6Z" fill="#f6d77a" />
			<path
				className="ease-spring origin-[19.8px_23.6px] transition-transform duration-500 [transform-box:view-box] group-hover:[transform:perspective(40px)_rotateY(-28deg)] motion-reduce:transition-none"
				d="M19.8 18.8 23.6 17.4v12.2l-3.8-1.2Z"
				fill="#d2481a"
				stroke="#1c1a22"
				strokeWidth="1.1"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
